import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import Cookies from 'js-cookie'
// import Axios from '../Helpers/Axios'
import axios from 'axios'

export default function username() {
    const { refId } = useParams();

    const [pageLoading, setPageLoading] = useState(true)

    useEffect(() => {

        if (refId) {
            handleVerify(refId)
        }

    }, [refId])

    const handleVerify = async (refId: string) => {
        if (!refId) {
            return alert('Please enter a username')
        }

        console.log('Ref Id: ', refId)
        console.log('BASE_API: ', import.meta.env.VITE_BASE_API)

        try {
            const res = await axios.get(`${import.meta.env.VITE_BASE_API}/sponsor/validate/${refId}`)

            console.log('Ref validation res: ', res?.data)

            if (res?.data?.ok) {
                // Set cookie with explicit options for better browser compatibility
                Cookies.set('sponsor', refId, {
                    expires: 30, // 30 days
                    path: '/',
                    sameSite: 'Lax'
                })

                setTimeout(() => {
                    window.location.href = `/`
                }, 500)
            }
            else {
                setPageLoading(false)
            }
        } catch (error) {
            console.error('Error validating sponsor:', error)
            setPageLoading(false)
        }
    }
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-900">
            {pageLoading ? (
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
                    <p className="text-white">Verifying referral...</p>
                </div>
            ) : (
                <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md mx-4">
                    <div className="text-red-500 text-5xl mb-4">
                        <i className="ri-error-warning-line"></i>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Invalid Referral</h2>
                    <p className="text-gray-600 mb-4">
                        The referral username "<strong>{refId}</strong>" was not found.
                    </p>
                    <p className="text-sm text-gray-500">
                        Please check the link or contact your referrer.
                    </p>
                </div>
            )}
        </div>
    )
}
